import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { FormatPoints } from "../../../../lib";
import { useNavigate } from "react-router";

const AereoPricingSummary = ({ envisionData, discountPoints = 0, fatorAirTicket = 0 }) => {
  const navigate = useNavigate();
  if (!envisionData.pricing) {
    notify("Ops, ocorreu um erro tente novamente mais tarde", "error");
    return navigate("/loja/passagens-aereas")
  };

  const pricing = envisionData.pricing || {};
  const totalFare = pricing.TotalFare || {};

  const passengers =
    (Array.isArray(envisionData.choosenFlight?.passengers) && envisionData.choosenFlight.passengers.length) ||
    (Array.isArray(envisionData.passengers) && envisionData.passengers.length) ||
    (Array.isArray(envisionData.travellers) && envisionData.travellers.length) ||
    fares.reduce((sum, f) => sum + (Number(f?.Quantity) || 0), 0) ||
    0;

  const convertToPoints = (value) => fatorAirTicket > 0 ? value / fatorAirTicket : 0;

  const totalMoney = totalFare.TotalFare + totalFare.TotalFee + totalFare.TotalTaxes;

  const breakdown = {
    passengers,
    farePoints: Math.ceil(convertToPoints((totalFare.TotalFare + totalFare.TotalFee) / passengers)),
    taxPoints: Math.ceil(convertToPoints(totalFare.TotalTaxes)),
    discountPoints: Math.ceil(convertToPoints(Number(discountPoints) || 0)),
    totalPoints: Math.max(
      0,
      Math.ceil(
        convertToPoints(totalMoney) -
          convertToPoints(Number(discountPoints) || 0),
      ),
    ),
  };

  return (
    <div className="mb-3">
      <p className="font-wl-700 text-mlg color-text-dark mb-3">Pedido</p>

      <Row className="mb-2">
        <Col>
          <p className="text-sm text-muted mb-0">
            {breakdown.passengers} passageiro
            {breakdown.passengers === 1 ? "" : "s"}
          </p>
        </Col>
        <Col className="text-end">
          <p className="text-sm color-text-dark mb-0">
            {FormatPoints(breakdown.farePoints)} pts
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p className="text-sm text-muted mb-0">Taxa de embarque</p>
        </Col>
        <Col className="text-end">
          <p className="text-sm color-text-dark mb-0">
            {FormatPoints(breakdown.taxPoints)} pts
          </p>
        </Col>
      </Row>

      {breakdown.discountPoints > 0 && (
        <Row className="mb-3">
          <Col>
            <p className="text-sm text-muted mb-0">Cupom de desconto</p>
          </Col>
          <Col className="text-end">
            <p
              className="text-sm mb-0"
              style={{ color: "#2D8D68", fontWeight: 500 }}
            >
              -{FormatPoints(breakdown.discountPoints)} pts
            </p>
          </Col>
        </Row>
      )}

      <Row className="font-wl-700">
        <Col>
          <p className="color-text-dark text-sm mb-0">Total do Pedido</p>
        </Col>
        <Col className="text-end">
          <p className="font-wl-700 text-sm color-text-dark mb-0">
            {FormatPoints(breakdown.totalPoints)} pts
          </p>
        </Col>
      </Row>
    </div>
  );
};

AereoPricingSummary.propTypes = {
  envisionData: PropTypes.shape({
    travellers: PropTypes.arrayOf(PropTypes.object),
    passengers: PropTypes.arrayOf(PropTypes.object),
    choosenFlight: PropTypes.shape({
      segments: PropTypes.shape({
        fares: PropTypes.arrayOf(PropTypes.object),
      }),
      passengers: PropTypes.arrayOf(PropTypes.object),
    }),
    segments: PropTypes.shape({
      fares: PropTypes.arrayOf(PropTypes.object),
    }),
    amount: PropTypes.shape({
      BRL: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ENVISION: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    pricing: PropTypes.shape({
      Fares: PropTypes.arrayOf(
        PropTypes.shape({
          Quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          FareAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          TaxesAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }),
      ),
      TotalFare: PropTypes.shape({
        GrandTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        Total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        TotalFare: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        TotalTaxes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        TotalFee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    }),
  }),
  discountPoints: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fatorAirTicket: PropTypes.number,
};

export default AereoPricingSummary;
